import urlPrefixes from '../../../constants/urlPrefixes';

/**
 * create page index part
 */
export default (pageIndex?: number | string): string =>
  Number(pageIndex) > 1 ? `/${urlPrefixes.page}/${pageIndex}` : '';
